export default __webpack_public_path__ + "static/media/NotFound.b9cc0ab8.svg";